import React from 'react'

const NoLiveGames = () => <div></div>

export default NoLiveGames